export default __webpack_public_path__ + "static/media/phone.8d600944.svg";